import gql from 'graphql-tag'
import di from 'di'

import addList from '@wittignl/js-core/apollo/mutations/addList'
import updateList from '@wittignl/js-core/apollo/mutations/updateList'
import deleteList from '@wittignl/js-core/apollo/mutations/deleteList'
import update from '@wittignl/js-core/apollo/mutations/update'

export default {

    create: function(loggerType){

        return di.get('apollo').mutate({

            mutation: gql`
                mutation ($loggerTypeInput: CreateLoggerTypeInput!) {
                    createLoggerType(input: $loggerTypeInput){
                        id
                        title
                        loggerPrice
                        usagePrice
                        createdAt
                    }
                }`,

            variables: {
                loggerTypeInput: loggerType
            }

            // updateQueries: {
            //     AllLoggerTypes: addList('createLoggerType', 'allLoggerTypes.items'),
            // }
        });
    },

    update: function(loggerType){

        return di.get('apollo').mutate({

            mutation: gql`
                mutation ($loggerTypeInput: UpdateLoggerTypeInput!) {
                    updateLoggerType(input: $loggerTypeInput){
                        id
                        title
                        loggerPrice
                        usagePrice
                        createdAt
                    }
                }`,

            variables: {
                loggerTypeInput: loggerType
            }

            // updateQueries: {
            //     AllLoggerTypes: updateList('updateUser', 'allUsers.items'),
            //     FindLoggerType: update('createLoggerType', 'findGarment')
            // }
        });
    }
}
